import { Head, Link, usePoll } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FeedbackForm from '@/frontend/features/Fde/WorkApprovals/FeedbackForm'
import type { Proposal, ApprovalCopy, ApprovalProject, Guidance } from '@/frontend/features/Fde/WorkApprovals/types'

function WorkApprovals({ project, proposals, guidance, copy }: { project: ApprovalProject; proposals: Proposal[]; guidance: Guidance; copy: ApprovalCopy }) {
  // Rails is authoritative; a reload/org switch replaces the entire list.
  usePoll(10_000, { only: ['proposals', 'guidance'] })
  return <main key={project.id} className="mx-auto w-full max-w-4xl space-y-8 px-5 py-8 md:px-8">
    <Head title={`${copy.title} · ${project.name}`} />
    <header className="space-y-2">
      <Link className="text-sm text-muted-foreground hover:underline" href={`/dashboard/discovery/overview?project_id=${project.id}`}>{copy.back_project}</Link>
      <h1 className="text-2xl font-semibold tracking-tight">{copy.title}</h1>
      <p className="text-sm text-muted-foreground">{project.name} · {copy.subtitle}</p>
    </header>
    <div className="divide-y rounded-xl border">
      {!proposals.length && <p className="p-6 text-sm text-muted-foreground">{copy.empty}</p>}
      {proposals.map(proposal => <Link key={proposal.id} href={proposal.path} className="block space-y-2 p-5 hover:bg-muted/30">
        <div className="flex flex-wrap items-center justify-between gap-2"><h2 className="font-medium">{proposal.scope.title}</h2><span className="text-xs text-muted-foreground">{proposal.status_label}</span></div>
        <p className="text-sm text-muted-foreground">{proposal.agent_name} · {proposal.task_title}</p>
        <p className="text-sm">{proposal.scope.benefit}</p>
      </Link>)}
    </div>
    <section className="space-y-3">
      <h2 className="font-medium">{copy.preference}</h2>
      {!guidance.preferences.length && <p className="text-sm text-muted-foreground">{copy.no_preferences}</p>}
      {guidance.preferences.map(rule => <div key={rule.id} className="border-l-2 pl-4 text-sm"><p className="font-medium">{rule.topic}</p><p className="whitespace-pre-wrap text-muted-foreground">{rule.body}</p></div>)}
    </section>
    <FeedbackForm key={project.id} projectId={project.id} copy={copy} />
  </main>
}
WorkApprovals.layout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>
export default WorkApprovals
